import $ from 'jquery';

const $window = $(window);
const breakpoint_lg_max = 1199;

function toggleNav() {
    if ($('.navigation__list').is(':hidden')) {
        showNav();
    } else {
        hideNav();
    }
}

function showNav() {
    var windowWidth = $window.outerWidth();
    if (windowWidth <= breakpoint_lg_max) {
        $('.navigation__list').css('display', 'flex');
        $('.navigation__hamburger').addClass('opened');
        $('.backdrop').addClass('visible');
        $('.header').addClass('nobg');
    }
}

function hideNav() {
    $('.navigation__list').removeAttr('style');
    $('.navigation__hamburger').removeClass('opened');
    $('.backdrop').removeClass('visible');
    $('.header').removeClass('nobg');
    hideSearch();
}

function toggleSearch(event) {
    if ($('.navigation__list_searchBar').hasClass('active')) {
        if (!$('.navigation__list_searchBar input').val()) {
            event.preventDefault();
        }
        hideSearch();
    } else {
        event.preventDefault();
        $('.navigation__list_searchBar input').val('');
        $('.navigation__list_searchBar').addClass('active');
        $('.navigation__list_searchBar input').trigger('focus');
    }
}

function hideSearch(force = false) {
    if (force === true) {
        $('.navigation__list_searchBar input').val('');
    }
    if (!$('.navigation__list_searchBar input').val()) {
        $('.navigation__list_searchBar').removeClass('active');
    }
}

$(function () {
    var lastWindowWidth = $window.width();
    $window.on('resize', function () {
        var windowWidth = $window.width();
        if (lastWindowWidth !== windowWidth) {
            hideNav();
            lastWindowWidth = windowWidth;
        }
    });

    $('.navigation__hamburger').on('click', toggleNav);
    $('body').on('click', hideSearch);
    $('.navigation__list_elem').on('click', function (event) {
        let child = $(this).children().first();
        if ($(child).hasClass('navigation__list_search')) {
            event.stopImmediatePropagation();
        } else {
            hideNav();
        }
    });
    $('.navigation__list_searchButton').on('click', function (event) {
        toggleSearch(event);
    });
    $('.navigation__list_searchBar a').on('click', function () {
        hideSearch(true);
    });
});
